import Section from '@widgets/components/section';
import { HashrateDynamics } from 'features/managers-perfomance/hashrate-dynamics/hashrate-dynamics';
import {
  ManagersTeamTable,
  MonthlyTeamGoal,
  MonthlyTeamResults,
  QuarterlyTeamBonus,
  QuarterlyTeamBonusResults,
  YearlyTeamBonusResults,
  YearlyTeamGoal,
} from 'features/managers-perfomance/team-result';

export const TeamResult = () => {
  return (
    <>
      <Section className="w-full">
        <div className="grid grid-cols-[1fr_auto_1fr] gap-5">
          <MonthlyTeamGoal />
          <div className="w-px bg-gray-600" />
          <MonthlyTeamResults />
        </div>
      </Section>
      <Section className="w-full">
        <div className="grid grid-cols-[1fr_auto_1fr] gap-5">
          <QuarterlyTeamBonus />
          <div className="w-px bg-gray-600" />
          <QuarterlyTeamBonusResults />
        </div>
      </Section>
      <Section className="w-full">
        <div className="grid grid-cols-[1fr_auto_1fr] gap-5">
          <YearlyTeamGoal />
          <div className="w-px bg-gray-600" />
          <YearlyTeamBonusResults />
        </div>
      </Section>
      <HashrateDynamics />
      <ManagersTeamTable />
    </>
  );
};
